import '../../../descope-text-field';

import PhoneFieldInternalInputBox, { componentName } from './PhoneFieldInternalInputBox';

customElements.define(componentName, PhoneFieldInternalInputBox);
